/* Actions */
// export const NAVIGATE_TO_SEARCH_PAGE = "NAVIGATE_TO_SEARCH_PAGE";

/* Mutations */
export const SET_CONVERSATION_HISTORY = "SET_CONVERSATION_HISTORY";
export const SET_SCORING_CONVERSATION_HISTORY =
  "SET_SCORING_CONVERSATION_HISTORY";
export const SET_MESSAGES = "SET_MESSAGES";
export const ADD_MESSAGE = "ADD_MESSAGE";
export const SET_NUM_RECEIVED_MESSAGES_SEEN = "SET_NUM_RECEIVED_MESSAGES_SEEN";
export const TOGGLE_SIDEBAR = "TOGGLE_SIDEBAR";
export const SET_SIDEBAR = "SET_SIDEBAR";
